import { Box, Stack } from "@mui/material";

import { useAppSelector } from "~/app/store";
import { AutostoreBin } from "~/features/autostoreBin";
import { usePortStatusQuery } from "~/hooks/usePortStatus";

import { getBinCompartmentOccupancy } from "~/lib/binCompartmentOccupancy";

import { selectIsShortSideBin } from "~/redux/selectors/workstationsSelectors";

export const MaintenanceFlagModalPort = ({ portId }: { portId: number }) => {
  const { error, activityState, binState } = usePortStatusQuery(portId);

  const compartmentOccupancy = getBinCompartmentOccupancy(binState);
  const isShortSideBin = useAppSelector(selectIsShortSideBin);

  return (
    <Stack sx={{ flex: "1 1 0" }}>
      {!error && (
        <Box
          sx={{
            position: "relative",
            padding: 2,
            display: "flex",
            justifyContent: isShortSideBin ? "center" : "stretch"
          }}
        >
          <Box
            sx={{
              padding: 1,
              borderRadius: "0.5em",
              border: `0.625em solid`,
              borderColor: "primary.main",
              maxWidth: "100%",
              width: isShortSideBin ? "max-content" : "100%",
              height: isShortSideBin ? "300px" : "auto"
            }}
          >
            <AutostoreBin
              state={activityState}
              binId={binState?.binState.binId}
              pickQuantity={0}
              pickCompartment={null}
              numberOfRows={
                binState?.binConfiguration?.horizontalCompartmentCount ?? 1
              }
              numberOfColumns={
                binState?.binConfiguration?.verticalCompartmentCount ?? 1
              }
              compartmentOccupancy={compartmentOccupancy}
              isShortSideBin={isShortSideBin}
            />
          </Box>
        </Box>
      )}
    </Stack>
  );
};
